export default __webpack_public_path__ + "static/media/CollegeVideo.5437bc37.mp4";